function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { forwardRef, Fragment, useEffect, useState, useRef, useContext } from "react";
import ChevronDownIcon from "../Icon/ChevronDown";
import HelperText from "../HelperText";
import Label from "../Label";
import Magazine from "../Magazine";
import Popper from "../Popper";
import Portal from "../Portal";
import { VisuallyHiddenElement } from "../VisuallyHiddenElement";
import ThemeContext from "../ThemeProvider/ThemeContext";
import useOnClickOutside from "../../hooks/useOnOutsideClick";
import { InputFieldset } from "../InputFieldset";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { CarinaContext } from "../CarinaProvider/index";
import { resolveIds } from "../../utils/resolveIds";
import { useStyle } from "./Dropdown.style";
import useComposedRef from "../../hooks/useComposedRef";
import { useId } from "@react-aria/utils";
import { useResize } from "../../hooks/useResizeObserver_NEXT";
export var DEPRECATED_COLOR_VARIANT = [
    'brand',
    'danger',
    'warning',
    'success'
];
var Dropdown = forwardRef(function(_param, ref) {
    var accessibilityLabel = _param.accessibilityLabel, ariaLabel = _param['aria-label'], ariaLabelledBy = _param['aria-labelledby'], ariaDescribedBy = _param['aria-describedby'], describedBy = _param.describedBy, disabled = _param.disabled, hasError = _param.hasError, helperText = _param.helperText, _hideLabel = _param.hideLabel, hideLabel = _hideLabel === void 0 ? false : _hideLabel, id = _param.id, isRequired = _param.isRequired, isRtl = _param.isRtl, labelRequiredTitle = _param.labelRequiredTitle, labelText = _param.labelText, _maxHeight = _param.maxHeight, maxHeight = _maxHeight === void 0 ? 192 : _maxHeight, onBlur = _param.onBlur, onFocus = _param.onFocus, onUpdate = _param.onUpdate, options = _param.options, placeholder = _param.placeholder, _popperjsModifiers = _param.popperjsModifiers, popperjsModifiers = _popperjsModifiers === void 0 ? [] : _popperjsModifiers, popperjsOptions = _param.popperjsOptions, portal = _param.portal, required = _param.required, rootID = _param.rootID, selected = _param.selected, _tabIndex = _param.tabIndex, tabIndex = _tabIndex === void 0 ? 0 : _tabIndex, testID = _param.testID, transitionProps = _param.transitionProps, _variant = _param.variant, variant = _variant === void 0 ? 'default' : _variant, zIndex = _param.zIndex, onClick = _param.onClick, rest = _objectWithoutProperties(_param, [
        "accessibilityLabel",
        'aria-label',
        'aria-labelledby',
        'aria-describedby',
        "describedBy",
        "disabled",
        "hasError",
        "helperText",
        "hideLabel",
        "id",
        "isRequired",
        "isRtl",
        "labelRequiredTitle",
        "labelText",
        "maxHeight",
        "onBlur",
        "onFocus",
        "onUpdate",
        "options",
        "placeholder",
        "popperjsModifiers",
        "popperjsOptions",
        "portal",
        "required",
        "rootID",
        "selected",
        "tabIndex",
        "testID",
        "transitionProps",
        "variant",
        "zIndex",
        "onClick"
    ]);
    var containerRef = useRef(null);
    var buttonRef = useRef(null);
    var composedRef = useComposedRef(buttonRef, ref);
    var labelRef = useRef(null);
    var popperRef = useRef(null);
    var _$ref = useResize(labelRef), labelHeight = _$ref.height;
    var theme = useContext(ThemeContext);
    var _$ref1 = _slicedToArray(useState(false), 2), isOpen = _$ref1[0], setIsOpen = _$ref1[1];
    var correctedVariant = DEPRECATED_COLOR_VARIANT.includes(variant) ? 'default' : variant;
    var isDefault = correctedVariant === 'default';
    var _$ref2;
    var _$ref3 = (_$ref2 = useContext(CarinaContext)) !== null && _$ref2 !== void 0 ? _$ref2 : {
        flags: {
            placeholderRemoval: false
        }
    }, placeholderRemoval = _$ref3.flags.placeholderRemoval;
    var _$ref4 = _slicedToArray(useState(!isDefault && (!!selected || !placeholderRemoval && !!placeholder)), 2), hasActiveLabelTransition = _$ref4[0], setHasActiveLabelTransition = _$ref4[1];
    var _$ref5 = _slicedToArray(useState(false), 2), hasFocus = _$ref5[0], setHasFocus = _$ref5[1];
    useEffect(function() {
        setHasActiveLabelTransition(!isDefault && (!!selected || !placeholderRemoval && !!placeholder || isOpen));
    }, [
        isDefault,
        placeholder,
        selected,
        isOpen
    ]);
    var _$ref6 = useStyle({
        isDisabled: disabled,
        hasError: hasError,
        correctedVariant: correctedVariant,
        isOpen: isOpen,
        isRtl: isRtl,
        variant: variant
    }), button = _$ref6.button, container = _$ref6.container, popper = _$ref6.popper, icon = _$ref6.icon, placeholderStyles = _$ref6.placeholder, text = _$ref6.text;
    var onDropdownClick = function() {
        if (onClick) {
            onClick(isOpen);
        }
        setIsOpen(function(curr) {
            return !curr;
        });
    };
    var onDropdownKeyPress = function(param) {
        var key = param.key;
        if (key === 'ArrowDown' || key === 'ArrowUp') {
            setIsOpen(true);
        }
    };
    var closeDropdown = function() {
        if (buttonRef && buttonRef.current !== null) {
            buttonRef.current.focus();
        }
        setIsOpen(false);
    };
    var handleBlur = function(event) {
        setHasFocus(false);
        if (!isOpen && onBlur) {
            onBlur(event);
        }
    };
    var handleSelect = function(option) {
        if (onUpdate) {
            onUpdate(option && option.value, option);
        }
        closeDropdown();
    };
    useOnClickOutside([
        containerRef,
        popperRef
    ], closeDropdown, isOpen);
    var renderSelectedText = function() {
        var Option = options ? options.find(function(option) {
            var selectedValue = typeof selected === 'object' ? selected === null || selected === void 0 ? void 0 : selected.value : selected;
            return typeof option === 'string' ? option === selectedValue : option.value === selectedValue;
        }) : undefined;
        if (typeof Option === 'string') {
            return Option;
        }
        if (typeof Option !== 'undefined') {
            return typeof Option.label === 'function' ? Option.label(theme) : Option.label;
        }
        if (!placeholderRemoval) {
            return _jsx("span", {
                css: placeholderStyles,
                children: placeholder
            });
        }
    };
    var selectedText = renderSelectedText();
    var dropdownId = useId(id);
    var _$ref7 = resolveIds(dropdownId, testID, 'label', true), labelId = _$ref7.id, labelTestID = _$ref7.testID;
    var _$ref8 = resolveIds(dropdownId, testID, 'value', true), selectedValueId = _$ref8.id, valueTestID = _$ref8.testID;
    var _$ref9 = resolveIds(dropdownId, testID, 'helper-text', true), helperTextId = _$ref9.id, helperTextTestID = _$ref9.testID;
    var composedLabelledBy = "".concat(ariaLabelledBy !== null && ariaLabelledBy !== void 0 ? ariaLabelledBy : labelId, " ").concat(selectedValueId);
    var composedAriaLabel = "".concat(ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : accessibilityLabel, " ").concat(selected ? selectedText : '');
    var handleFocus = function(event) {
        setHasFocus(true);
    };
    var _$ref10;
    return _jsxs(Fragment, {
        children: [
            _jsxs("div", {
                css: container,
                ref: containerRef,
                children: [
                    labelText && _jsx(Label, {
                        hasEndIcon: true,
                        id: labelId,
                        isAnimated: hasActiveLabelTransition,
                        isDisabled: disabled,
                        isHidden: variant === 'grid' || hideLabel,
                        isRequired: isRequired || required,
                        isRtl: isRtl,
                        isInputFocused: hasFocus,
                        ref: labelRef,
                        requiredTitle: labelRequiredTitle,
                        testID: labelTestID,
                        variant: correctedVariant,
                        children: labelText
                    }),
                    selectedText && _jsx(VisuallyHiddenElement, {
                        id: selectedValueId,
                        testID: valueTestID,
                        children: selectedText
                    }),
                    _jsxs("button", _objectSpread({}, rest, {
                        "aria-expanded": isOpen,
                        "aria-haspopup": "true",
                        "aria-invalid": hasError,
                        "aria-label": ariaLabel || accessibilityLabel ? composedAriaLabel : undefined,
                        "aria-labelledby": ariaLabel || accessibilityLabel ? undefined : composedLabelledBy,
                        "aria-disabled": disabled,
                        "aria-describedby": (_$ref10 = ariaDescribedBy !== null && ariaDescribedBy !== void 0 ? ariaDescribedBy : describedBy) !== null && _$ref10 !== void 0 ? _$ref10 : helperText ? helperTextId : undefined,
                        css: button,
                        disabled: disabled,
                        id: dropdownId,
                        onBlur: handleBlur,
                        onClick: onDropdownClick,
                        onFocus: handleFocus,
                        onKeyDown: onDropdownKeyPress,
                        ref: composedRef,
                        tabIndex: disabled ? -1 : tabIndex,
                        type: "button"
                    }, injectTestId(testID), {
                        children: [
                            _jsx("div", {
                                css: text,
                                children: selectedText
                            }),
                            _jsx("span", {
                                css: icon,
                                children: _jsx(ChevronDownIcon, {
                                    color: disabled ? theme.font.color.disabled : theme.font.color.soft,
                                    size: "s"
                                })
                            })
                        ]
                    })),
                    _jsx(InputFieldset, {
                        hasActiveLabelTransition: hasActiveLabelTransition,
                        hasError: hasError,
                        hideLabel: hideLabel,
                        id: dropdownId,
                        isDisabled: disabled,
                        isRequired: isRequired !== null && isRequired !== void 0 ? isRequired : required,
                        isRtl: isRtl,
                        labelText: labelText,
                        testID: testID,
                        top: labelHeight,
                        variant: correctedVariant
                    }),
                    _jsx(Portal, {
                        portal: portal && rootID ? rootID : portal,
                        children: _jsx(Popper, {
                            animationFunction: "productive",
                            flip: true,
                            hasShadow: true,
                            isOpen: isOpen,
                            isRtl: isRtl,
                            isSameWidth: true,
                            placement: "bottom-start",
                            popperjsModifiers: popperjsModifiers,
                            popperjsOptions: popperjsOptions,
                            popperRef: popperRef,
                            popperStyles: popper,
                            transitionProps: transitionProps,
                            triggerRef: buttonRef,
                            zIndex: zIndex,
                            children: _jsx(Magazine, {
                                options: options || [],
                                optionsRole: "menuitemradio",
                                theme: theme,
                                handleClose: closeDropdown,
                                onUpdate: handleSelect,
                                selected: typeof selected === 'string' ? selected : selected === null || selected === void 0 ? void 0 : selected.value,
                                magazineStyleObject: {
                                    width: '100%',
                                    maxHeight: maxHeight,
                                    position: 'static',
                                    padding: "".concat(theme.spacing[3], " 0"),
                                    boxShadow: 'none'
                                },
                                focusOnMount: true,
                                isRtl: isRtl,
                                testID: testID,
                                zIndex: zIndex
                            })
                        })
                    })
                ]
            }),
            variant !== 'grid' && _jsx(HelperText, {
                id: helperTextId,
                testID: helperTextTestID,
                isRtl: isRtl,
                hasError: hasError,
                children: helperText
            })
        ]
    });
});
export { Dropdown };
export default Dropdown;
